/**
 * Seeq REST API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 66.223.0-v202611042005-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

/**
 * The list of searches based on properties
 */
export interface PropertySearchV1 {
    /**
     * If provided, only search for items that are descendants of this asset. The empty GUID (00000000-0000-0000-0000-000000000000) indicates the shared root of all asset trees (for example, the empty GUID with `level=1` will find all root assets).
     */
    "ancestorId"?: string;
    /**
     * A list of ancestor predicate filters. Each predicate specifies property filters for an ancestor and an optional level (1 = direct parent, 2 = grandparent, etc.). When provided with ancestorId, constrains results to items whose ancestors at the specified level match the given property filters. May be used with or without ancestorId. Multiple candidate ancestors can be expressed with an ID predicate using the WITHIN operator.
     */
    "ancestorPredicates"?: Array<models.AncestorFilterInputV1>;
    /**
     * If provided, only search for items that are scoped to the workbooks contained in this folder
     */
    "folderId"?: string;
    /**
     * If true, the items found by this search will be included in the output. If false, then the results will be excluded from the output (even if found by another search)
     */
    "isInclude": boolean;
    /**
     * If provided, only return items exactly this many levels below the ancestor (1 = direct children, 2 = grandchildren, etc.). Requires ancestorId. If omitted, descendants at all depths are returned.
     */
    "level"?: number;
    /**
     * A list of predicates by which to filter the items
     */
    "predicates"?: Array<models.PropertyFilterInputV1>;
    /**
     * The priority of this search. Searches execute in descending order value, so when the same item appears in multiple searches, the search with the lowest order value executes last and wins. If not specified, the search is treated as the lowest priority and executes first. Searches with the same order value (or none) execute in ascending ID order, so the search with the higher ID wins (deterministic).
     */
    "searchOrder"?: number;
    /**
     * The type of search
     */
    "searchType": SearchTypeEnum;
    /**
     * Optional field to sort by. If omitted, results are returned in unspecified order.
     */
    "sortField"?: SortFieldEnum;
    /**
     * Sort direction, applied only when sortField is set
     */
    "sortOrder"?: SortOrderEnum;
    /**
     * A list of types by which to filter the items
     */
    "types": Array<string>;
}

export const SearchTypeEnum = {
    SWAPACROSSASSETS: 'SWAP_ACROSS_ASSETS',
    FIXEDLIST: 'FIXED_LIST',
    PROPERTY: 'PROPERTY',
    MATERIALIZEDTABLEUUIDCOLUMN: 'MATERIALIZED_TABLE_UUID_COLUMN',
    HIERARCHY: 'HIERARCHY',
    STOREDTABLE: 'STORED_TABLE'
} as const;

export type SearchTypeEnum = typeof SearchTypeEnum[keyof typeof SearchTypeEnum];
export const SortFieldEnum = {
    ID: 'ID',
    Name: 'Name',
    Description: 'Description'
} as const;

export type SortFieldEnum = typeof SortFieldEnum[keyof typeof SortFieldEnum];
export const SortOrderEnum = {
    ASC: 'ASC',
    DESC: 'DESC'
} as const;

export type SortOrderEnum = typeof SortOrderEnum[keyof typeof SortOrderEnum];
